G.WorldSidePanelWidgetButtonNotification = function(x, y) {
  Phaser.Group.call(this, game);
  this.position.setTo(x, y);

  this.amount = 0;

  this.bg = G.makeImage(0, -5, "reddot", 0.5, this);
  this.amountTxt = new G.Text(1, -5, "0", {
    style: "font-white",
    fontSize: 25,
  }, 0.5);
  this.add(this.amountTxt);
  this.alpha = 0;

  G.sb("widgetButtonAddNotification").add(this.addNotification, this);
  G.sb("widgetButtonRemoveNotification").add(this.removeNotification, this);
};

G.WorldSidePanelWidgetButtonNotification.prototype = Object.create(Phaser.Group.prototype);

G.WorldSidePanelWidgetButtonNotification.prototype.addNotification = function() {
  this.amount++;

  this.tweenAlpha(1);
  this.setTextAmount(this.amount);
};

G.WorldSidePanelWidgetButtonNotification.prototype.removeNotification = function() {
  this.amount = Math.max(this.amount-1, 0);

  if (this.amount == 0) {
    this.tweenAlpha(0);
  }

  this.setTextAmount(this.amount);
};

G.WorldSidePanelWidgetButtonNotification.prototype.tweenAlpha = function(newAlpha) {
  if (this.alpha === newAlpha) return;

  if (this.alphaTween) {
    this.alphaTween.stop();
    this.alphaTween = null;
  }

  this.alphaTween = game.add.tween(this) 
    .to({alpha:  newAlpha}, 300, Phaser.Easing.Sinusoidal.Out, true);
};

G.WorldSidePanelWidgetButtonNotification.prototype.setTextAmount = function(amount) {
  this.amountTxt.setText(amount.toString());

  if (this.scaleTween) {
    this.scaleTween.stop();
    this.scaleTween = null;
  }

  this.scale.setTo(1);
  this.scaleTween = game.add.tween(this.scale)
    .to({x: 1.2, y: 1.2}, 300, Phaser.Easing.Sinusoidal.Out, true, 0, 0, true);

};